"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CargaDatePorCor = void 0;
var bson_1 = require("bson");
var CargaDatePorCor = /** @class */ (function () {
    function CargaDatePorCor(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.dateAndTime, dateAndTime = _c === void 0 ? '' : _c;
        this._id = _id;
        this.dateAndTime = dateAndTime;
    }
    return CargaDatePorCor;
}());
exports.CargaDatePorCor = CargaDatePorCor;
//# sourceMappingURL=CargaDatePorCor.js.map